import Signal, { Binder, Req } from "badmfck-signal"
import { IExecutorResponse } from "badmfck-signal/dist/DataProvider"
import { IProject } from "./services/Projects"
import {
	AUTH_STATE,
	IEnableTwoFactorResponse,
	ILoginCompany,
	ILoginTwoFactorChallenge,
	TUser
} from "./services/AuthService"
//!TID: move type;

export class GD {
	//AUTHENTICATION
	static REQ_AUTH_TOKEN = new Req<void, string | null>(undefined, "REQ_AUTH_TOKEN")
	static S_AUTH_STATUS = new Signal<AUTH_STATE>("S_AUTH_STATUS")
	static S_AUTH_LOG_OUT = new Signal<void>("S_AUTH_LOG_OUT")
	static REQ_AUTH_LOGIN = new Req<IAuthForm, IError | ILoginTwoFactorChallenge | null>(
		undefined,
		"REQ_AUTH_LOGIN"
	)
	static REQ_AUTH_2FA_ENABLE = new Req<
		{ method: TTwoFactorMethod },
		IAPIResponse<IEnableTwoFactorResponse>
	>(undefined, "REQ_AUTH_2FA_ENABLE")
	static REQ_AUTH_2FA_DISABLE = new Req<{ password?: string }, IError | null>(
		undefined,
		"REQ_AUTH_2FA_DISABLE"
	)
	static REQ_AUTH_2FA_VALIDATE = new Req<
		{ totp: string; method: TTwoFactorMethod },
		IError | null
	>(undefined, "REQ_AUTH_2FA_VALIDATE")

	static REQ_INVITE_USER = new Req<
		{ email: string; role?: string; name: string; team_uid?: string },
		IAPIResponse<boolean>
	>(undefined, "REQ_INVITE_USER")
	static REQ_INVITE_TEMPLATE = new Req<void, IAPIResponse<IInvite>>(
		undefined,
		"REQ_INVITE_TEMPLATE"
	)
	static REQ_INVITES_LIST = new Req<void, IAPIResponse<IInvite[]>>(
		undefined,
		"REQ_INVITES_LIST"
	)
	static REQ_INVITE_DELETE = new Req<{ id: string }, IAPIResponse<boolean>>(
		undefined,
		"REQ_INVITE_DELETE"
	)
	static REQ_INVITE_GET = new Req<{ code: string }, IAPIResponse<IInvite>>(
		undefined,
		"REQ_INVITE_GET"
	)
	static REQ_INVITE_SIGNUP = new Req<
		{ token: string; password: string },
		IAPIResponse<boolean>
	>(undefined, "REQ_INVITE_SIGNUP")
	static S_INVITES_LIST_UPDATED = new Signal<IInvite[]>("S_INVITES_LIST_UPDATED")

	static REQ_AUTH_SIGNUP = new Req<
		ICorporateSignupBody,
		IAPIResponse
	>(undefined, "REQ_AUTH_SIGNUP")

	// Private self-registration (users/register + email confirmation flow)
	static REQ_AUTH_REGISTER = new Req<IRegisterBody, IAPIResponse<IStatusResponse>>(
		undefined,
		"REQ_AUTH_REGISTER"
	)
	static REQ_AUTH_REGISTER_CONFIRM = new Req<
		IRegisterConfirmBody,
		IAPIResponse<IStatusResponse>
	>(undefined, "REQ_AUTH_REGISTER_CONFIRM")
	static REQ_AUTH_REGISTER_RESEND = new Req<
		IRegisterResendBody,
		IAPIResponse<IStatusResponse>
	>(undefined, "REQ_AUTH_REGISTER_RESEND")
	static REQ_REFERRAL_CHECK = new Req<
		IReferralCheckBody,
		IAPIResponse<IReferralCheckResponse>
	>(undefined, "REQ_REFERRAL_CHECK")
	static REQ_COMPANY_REFERRAL = new Req<
		void,
		IAPIResponse<ICompanyReferralResponse>
	>(undefined, "REQ_COMPANY_REFERRAL")

	// Onboarding state for the currently logged-in private account (from login).
	static REQ_ONBOARDING = new Req<void, IOnboarding | null>(undefined, "REQ_ONBOARDING")
	static S_ONBOARDING_UPDATED = new Signal<IOnboarding | null>("S_ONBOARDING_UPDATED")
	// Update the cached onboarding KYC status (e.g. lift the gate on approval).
	static REQ_ONBOARDING_SET_STATUS = new Req<TKycStatus, void>(
		undefined,
		"REQ_ONBOARDING_SET_STATUS"
	)

	static REQ_PROFILE = new Req<void, TUser | null>(undefined, "REQ_PROFILE")
	static S_PROFILE_UPDATED = new Signal<Partial<TUser>>("S_PROFILE_UPDATED")

	static REQ_COMPANY = new Req<void, ILoginCompany | null>(undefined, "REQ_COMPANY")
	static REQ_COMPANY_REFRESH = new Req<void, ILoginCompany | null>(
		undefined,
		"REQ_COMPANY_REFRESH"
	)
	static S_COMPANY_UPDATED = new Signal<ILoginCompany | null>("S_COMPANY_UPDATED")
	static REQ_COMPANY_ISSUERS = new Req<
		void | { with_buyers?: boolean },
		IAPIResponse<ICompanyIssuer[]>
	>(undefined, "REQ_COMPANY_ISSUERS")
	static S_ISSUER_CHANGED = new Signal<number | null>("S_ISSUER_CHANGED")
	static S_COMPANY_ISSUERS_REFRESH = new Signal<void>("S_COMPANY_ISSUERS_REFRESH")

	static REQ_PROJECT_ID = new Req<void, number>(undefined, "REQ_PROJECT_ID")

	static S_SELECT_PROJECT = new Signal<void>("S_SELECT_PROJECT")

	static REQ_FILES_SAVE = new Req<any, IAPIResponse>()
	static REQ_FILES_LIST = new Req<
		{ target_id: number; target_type: string },
		IAPIResponse
	>()
	static REQ_FILE_DELETE = new Req<
		{ target_id: number; target_type: string; id: string | number },
		IAPIResponse
	>()
	static REQ_FILE_DOWNLOAD = new Req<
		{ target_id: number; target_type: string; id: string | number },
		IAPIResponse
	>()

	// HTTP
	static REQ_BASIC = new Req<RequestConfig, IHTTPResponse>(undefined, "REQ_BASIC")
	static REQ_API = new Req<IAPIRequest, IAPIResponse>(undefined, "REQ_API")
	static S_HTTP_BUSY = new Signal<boolean>("S_HTTP_BUSY")

	// PROJECT
	static B_PROJECTS = new Binder<void, IExecutorResponse<IProject[]>>("B_PROJECTS")
	static B_SELECTED_PROJECT = new Binder<void, IProject | null>("B_PROJECT")
	static REQ_PROJECT_ID_BY_NAME = new Req<string, number>(undefined, "REQ_PROJECT_ID")
	static REQ_PROJECT_BY_ID = new Req<{ projectID: number }, IProject | null>(
		undefined,
		"REQ_PROJECT_BY_ID"
	)
	static S_PROJECT_EDITOR = new Signal<{ projectID: number } | null>("S_PROJECT_EDITOR")
	static REQ_PROJECT_SAVE = new Req<IProject, IProject | IError | null>(
		undefined,
		"REQ_PROJECT_BY_ID"
	)
	static S_PROJECT_SELECTED = new Signal<IProject>("S_PROJECT_SELECTED")
	static REQ_CURRENT_PROJECT = new Req<void, IProject | null>(
		undefined,
		"REQ_CURRENT_PROJECT"
	)

	static REQ_PAYMENTS = new Req<void, IAPIResponse<IPayment[]>>(undefined, "REQ_PAYMENTS")
	static REQ_PAYOUTS = new Req<void, IAPIResponse<IPayout[]>>(undefined, "REQ_PAYOUTS")
	static REQ_COMPANY_TRANSACTIONS = new Req<
		void | ICompanyTransactionFilter,
		IAPIResponse<ICompanyTransactionsResponse>
	>(undefined, "REQ_COMPANY_TRANSACTIONS")
	static REQ_COMPANY_TRANSACTIONS_CARDS = new Req<
		void | ICompanyTransactionFilter,
		IAPIResponse<ICompanyTransactionsResponse>
	>(undefined, "REQ_COMPANY_TRANSACTIONS_CARDS")
	static REQ_COMPANY_TRANSACTIONS_ALL = new Req<
		void | ICompanyTransactionFilter,
		IAPIResponse<ICompanyTransactionsResponse>
	>(undefined, "REQ_COMPANY_TRANSACTIONS_ALL")
	static REQ_COMPANY_TRANSACTION_FILTERS = new Req<
		void,
		IAPIResponse<ICompanyTransactionFiltersResponse>
	>(undefined, "REQ_COMPANY_TRANSACTION_FILTERS")
	static REQ_COMPANY_TRANSACTION_PRESETS = new Req<
		void,
		IAPIResponse<ITransactionFilterPreset[]>
	>(undefined, "REQ_COMPANY_TRANSACTION_PRESETS")
	static REQ_COMPANY_TRANSACTION_PRESET_CREATE = new Req<
		ITransactionFilterPresetWrite,
		IAPIResponse<ITransactionFilterPreset>
	>(undefined, "REQ_COMPANY_TRANSACTION_PRESET_CREATE")
	static REQ_COMPANY_TRANSACTION_PRESET_UPDATE = new Req<
		ITransactionFilterPresetUpdate,
		IAPIResponse<ITransactionFilterPreset>
	>(undefined, "REQ_COMPANY_TRANSACTION_PRESET_UPDATE")
	static REQ_COMPANY_TRANSACTION_PRESET_DELETE = new Req<
		{ uid: string },
		IAPIResponse<IStatusResponse>
	>(undefined, "REQ_COMPANY_TRANSACTION_PRESET_DELETE")
	static REQ_COMPANY_TRANSACTION_DETAILS = new Req<
		{ operation_id: number },
		IAPIResponse<import("./services/transactionDetails").ITransactionDetails>
	>(undefined, "REQ_COMPANY_TRANSACTION_DETAILS")
	static REQ_COMPANY_TRANSACTION_ACCOUNT = new Req<
		{ account_id: number },
		IAPIResponse<ICompanyTransactionAccountResponse>
	>(undefined, "REQ_COMPANY_TRANSACTION_ACCOUNT")
	static REQ_COMPANY_TRANSACTIONS_CARD = new Req<
		{ card_uid: string } & ICompanyTransactionFilter,
		IAPIResponse<ICompanyTransactionsResponse>
	>(undefined, "REQ_COMPANY_TRANSACTIONS_CARD")
	static REQ_COMPANY_TRANSACTIONS_BUYER = new Req<
		{ user_uid: string } & ICompanyTransactionFilter,
		IAPIResponse<ICompanyTransactionsResponse>
	>(undefined, "REQ_COMPANY_TRANSACTIONS_BUYER")
	static REQ_STATS_SPEND_OVERVIEW = new Req<
		IStatsOverviewParams | void,
		IAPIResponse<ISpendOverviewStats>
	>(undefined, "REQ_STATS_SPEND_OVERVIEW")
	static REQ_STATS_CARDS_SPEND_OVERVIEW = new Req<
		IStatsOverviewParams | void,
		IAPIResponse<ISpendOverviewStats>
	>(undefined, "REQ_STATS_CARDS_SPEND_OVERVIEW")
	static REQ_STATS_OVERVIEW = new Req<
		IStatsOverviewParams | void,
		IAPIResponse<IStatsOverviewStats>
	>(undefined, "REQ_STATS_OVERVIEW")
	static REQ_STATS_BY_CARD = new Req<
		IStatsOverviewParams | void,
		IAPIResponse<IStatsByCardStats>
	>(undefined, "REQ_STATS_BY_CARD")
	static REQ_STATS_TEAMS_MONTH = new Req<
		IStatsOverviewParams | void,
		IAPIResponse<ITeamsMonthStats>
	>(undefined, "REQ_STATS_TEAMS_MONTH")
	static REQ_STATS_TOP_TEAMS = new Req<
		(IStatsOverviewParams & { limit?: number }) | void,
		IAPIResponse<ITopTeamsStats>
	>(undefined, "REQ_STATS_TOP_TEAMS")
	static REQ_STATS_TOP_BUYERS = new Req<
		(IStatsOverviewParams & { limit?: number }) | void,
		IAPIResponse<ITopBuyersStats>
	>(undefined, "REQ_STATS_TOP_BUYERS")
	static REQ_STATS_DECLINED_BY_TEAM = new Req<
		{ days?: number; team_uid?: string } | void,
		IAPIResponse<IDeclinedByTeamStats>
	>(undefined, "REQ_STATS_DECLINED_BY_TEAM")
	static REQ_STATS_DECLINED_BY_BUYER = new Req<
		{ days?: number; buyer_uid?: string; team_uid?: string } | void,
		IAPIResponse<IDeclinedByBuyerStats>
	>(undefined, "REQ_STATS_DECLINED_BY_BUYER")

	// CARD HOLDER
	static REQ_CARDHOLDER_CREATE = new Req<ICardHolderRaw, IAPIResponse<ICardHolderSaved>>(
		undefined,
		"REQ_CARDHOLDER_ADD"
	)
	static REQ_CARDHOLDER_TEMPLATE = new Req<void, IAPIResponse<ICardHolderRaw>>(
		undefined,
		"REQ_CARDHOLDER_TEMPLATE"
	)
	static REQ_CARDHOLDERS = new Req<void, IAPIResponse<ICardHolderSaved[]>>(
		undefined,
		"REQ_CARDHOLDERS"
	)
	static REQ_CARDHOLDER_GET = new Req<string, IAPIResponse<ICardHolderSaved>>(
		undefined,
		"REQ_CARDHOLDER_GET"
	)
	static REQ_CARDHOLDER_UPDATE = new Req<ICardHolderSaved, IAPIResponse<IStatusResponse>>(
		undefined,
		"REQ_CARDHOLDER_UPDATE"
	)
	static REQ_CARDHOLDER_COMPLETION_GET = new Req<
		{ uid: string; issuer?: number },
		IAPIResponse<ICardHolderResponse>
	>(undefined, "REQ_CARDHOLDER_COMPLETION_GET")
	static REQ_CARDHOLDER_COMPLETION_UPDATE = new Req<
		ICardHolderResponse,
		IAPIResponse<IStatusResponse>
	>(undefined, "REQ_CARDHOLDER_COMPLETION_UPDATE")
	static REQ_CARDHOLDER_FORM = new Req<void | { issuer?: number; bin?: string }, IAPIResponse<ICardHolderResponse>>(
		undefined,
		"REQ_CARDHOLDER_FORM"
	)
	static REQ_CARDHOLDER_SUBMIT = new Req<void | { issuer?: number; bin?: string }, IAPIResponse<ICardHolderSubmitResponse>>(
		undefined,
		"REQ_CARDHOLDER_SUBMIT"
	)
	static S_CARDHOLDERS_LIST_UPDATED = new Signal<ICardHolderSaved[]>(
		"S_CARDHOLDERS_LIST_UPDATED"
	)

	// CARDS
	static REQ_CARDS = new Req<void | { force?: boolean; issuer?: number }, IAPIResponse<ICardSaved[]>>(
		undefined,
		"REQ_CARDS"
	)
	/** One page of cards/list with totals (`with_meta`). Older backends answer with the bare array. */
	static REQ_CARDS_PAGE = new Req<
		ICardListQuery & { limit?: number; offset?: number },
		IAPIResponse<IListPage<ICardSaved, ICardListSummary> | ICardSaved[]>
	>(undefined, "REQ_CARDS_PAGE")
	static REQ_GET_CARD_TEMPLATE = new Req<
		{ card_holder_uid?: string; issuer?: number },
		IAPIResponse<ICardRaw>
	>(undefined, "REQ_GET_CARD_TEMPLATE")
	static REQ_CREATE_CARD = new Req<ICardSaved, IAPIResponse<ICardRaw>>(
		undefined,
		"REQ_CREATE_CARD"
	)
	static REQ_GET_CARD = new Req<
		{ uid: string; card_holder_uid: string },
		IAPIResponse<ICardSaved>
	>(undefined, "REQ_GET_CARD")
	static REQ_UPDATE_CARD = new Req<ICardUpdate, IAPIResponse<IStatusResponse>>(
		undefined,
		"REQ_UPDATE_CARD"
	)
	static REQ_CARD_NAME_GET = new Req<{ uid: string }, IAPIResponse<ICardEditModel>>(undefined, "REQ_CARD_NAME_GET")
	static REQ_CARD_NAME_SET = new Req<ICardNameUpdate, IAPIResponse<IStatusResponse>>(undefined, "REQ_CARD_NAME_SET")
	static REQ_CARD_LIMITS_GET = new Req<{ uid: string }, IAPIResponse<ICardEditModel>>(undefined, "REQ_CARD_LIMITS_GET")
	static REQ_CARD_LIMITS_SET = new Req<ICardLimitsUpdate, IAPIResponse<IStatusResponse>>(undefined, "REQ_CARD_LIMITS_SET")
	static REQ_CARD_TX_CONTROL = new Req<ICardTxControl, IAPIResponse<IStatusResponse>>(
		undefined,
		"REQ_CARD_TX_CONTROL"
	)
	static REQ_CARD_TOPUP = new Req<ICardTopUp, IAPIResponse<IStatusResponse>>(
		undefined,
		"REQ_CARD_TOPUP"
	)
	static REQ_CARD_TOPUP_TEMPLATE = new Req<void, IAPIResponse<ICardTopUp>>(
		undefined,
		"REQ_CARD_TOPUP_TEMPLATE"
	)
	static REQ_CARD_TOPUPS = new Req<{ card_uid: string }, IAPIResponse<ICardTopUpSaved[]>>(
		undefined,
		"REQ_CARD_TOPUPS"
	)
	static REQ_CARD_TOPUP_GET = new Req<
		{ id: string | number },
		IAPIResponse<ICardTopUpSaved>
	>(undefined, "REQ_CARD_TOPUP_GET")
	static REQ_CARD_WITHDRAW = new Req<ICardWithdrawal, IAPIResponse<IStatusResponse>>(
		undefined,
		"REQ_CARD_WITHDRAW"
	)
	static REQ_CARD_WITHDRAW_LIST = new Req<
		{ card_uid: string },
		IAPIResponse<ICardWithdrawalSaved[]>
	>(undefined, "REQ_CARD_WITHDRAW_LIST")
	static REQ_CARD_WITHDRAW_GET = new Req<
		{ id: number | string },
		IAPIResponse<ICardWithdrawalSaved>
	>(undefined, "REQ_CARD_WITHDRAW_GET")
	static REQ_CARD_3DS_LIST = new Req<
		ICard3dsListRequest,
		IAPIResponse<ICard3dsCode[]>
	>(undefined, "REQ_CARD_3DS_LIST")
	static REQ_CARD_3DS_REFRESH = new Req<
		ICard3dsRefreshRequest,
		IAPIResponse<ICard3dsRefreshResponse>
	>(undefined, "REQ_CARD_3DS_REFRESH")
	static REQ_FREEZE_CARD = new Req<{ card_uid: string }, IAPIResponse<IStatusResponse>>(
		undefined,
		"REQ_FREEZE_CARD"
	)
	static REQ_UNFREEZE_CARD = new Req<{ card_uid: string }, IAPIResponse<IStatusResponse>>(
		undefined,
		"REQ_UNFREEZE_CARD"
	)
	static REQ_BLOCK_CARD = new Req<
		{ card_uid: string; type?: "buyer" | "company" },
		IAPIResponse<ICardBlockResponse>
	>(undefined, "REQ_BLOCK_CARD")
	static REQ_BLOCK_CARD_PREVIEW = new Req<
		{ card_uid: string; type?: "buyer" | "company" },
		IAPIResponse<ICardBlockPreview>
	>(undefined, "REQ_BLOCK_CARD_PREVIEW")
	static REQ_BLOCK_CARD_STATUS = new Req<
		{ operation_uid: string },
		IAPIResponse<ICardBlockStatus>
	>(undefined, "REQ_BLOCK_CARD_STATUS")
	static REQ_CARD_TRANSACTIONS = new Req<
		{ uid: string; card_holder_uid: string },
		IAPIResponse<ICardTransaction[]>
	>(undefined, "REQ_CARD_TRANSACTIONS")
	static S_CARDS_LIST_UPDATED = new Signal<ICardSaved[]>("S_CARDS_LIST_UPDATED")
	static S_CARD_UPDATED = new Signal<ICardSaved>("S_CARD_UPDATED")

	// KYC (task M-15)
	static REQ_KYC_START = new Req<void | IKycStartBody, IAPIResponse<IKycStartResponse>>(
		undefined,
		"REQ_KYC_START"
	)
	static REQ_KYC_STATUS = new Req<void | IKycStatusRequest, IAPIResponse<IKycStatusResponse>>(
		undefined,
		"REQ_KYC_STATUS"
	)
	static REQ_KYC_ISSUERS = new Req<void | IKycStatusRequest, IAPIResponse<IKycIssuer[]>>(
		undefined,
		"REQ_KYC_ISSUERS"
	)
	static REQ_KYC_PHONE_GET = new Req<void | IKycPhoneRequest, IAPIResponse<any>>(
		undefined,
		"REQ_KYC_PHONE_GET"
	)
	static REQ_KYC_PHONE = new Req<IKycPhoneBody, IAPIResponse<any>>(
		undefined,
		"REQ_KYC_PHONE"
	)
	static REQ_CRYPTO_COINS = new Req<void, IAPIResponse<ICryptoCoin[]>>(undefined, "REQ_CRYPTO_COINS")
	static REQ_CRYPTO_QUOTE = new Req<{ coin_key: string; amount: number }, IAPIResponse<ICryptoQuote>>(
		undefined,
		"REQ_CRYPTO_QUOTE"
	)
	static REQ_CRYPTO_ADDRESS = new Req<{ coin_key?: string } | void, IAPIResponse<ICryptoAddress>>(
		undefined,
		"REQ_CRYPTO_ADDRESS"
	)
	static REQ_CRYPTO_DEPOSITS = new Req<void, IAPIResponse<ICryptoDeposit[]>>(
		undefined,
		"REQ_CRYPTO_DEPOSITS"
	)

	// TEAMS
	static REQ_TEAMS_LIST = new Req<
		void | Record<string, unknown>,
		IAPIResponse<ITeamSaved[]>
	>(undefined, "REQ_TEAMS_LIST")
	/** One page of teams/list with totals (`with_meta`). Older backends answer with the bare array. */
	static REQ_TEAMS_PAGE = new Req<
		IListQuery & { limit?: number; offset?: number },
		IAPIResponse<IListPage<ITeamSaved, ITeamListSummary> | ITeamSaved[]>
	>(undefined, "REQ_TEAMS_PAGE")
	static REQ_TEAM_CREATE = new Req<ITeamRaw, IAPIResponse<ITeamSaved>>(
		undefined,
		"REQ_TEAM_CREATE"
	)
	static REQ_TEAM_UPDATE = new Req<ITeamSaved, IAPIResponse<IStatusResponse>>(
		undefined,
		"REQ_TEAM_UPDATE"
	)
	static REQ_TEAM_GET = new Req<string, IAPIResponse<ITeamSaved>>(
		undefined,
		"REQ_TEAM_GET"
	)
	static REQ_TEAM_USERS = new Req<{ uid: string; issuer?: number }, IAPIResponse<ITeamUser[]>>(
		undefined,
		"REQ_TEAM_USERS"
	)
	static REQ_TEAM_TRANSACTIONS = new Req<
		{ uid: string } & ICompanyTransactionFilter,
		IAPIResponse<ICompanyTransactionsResponse>
	>(undefined, "REQ_TEAM_TRANSACTIONS")
	static REQ_TEAM_STATS_MONEY_INFLOW = new Req<
		{ uid: string; days?: number; currency?: string; issuer?: number },
		IAPIResponse<ITeamMoneyInflowStats>
	>(undefined, "REQ_TEAM_STATS_MONEY_INFLOW")
	static REQ_TEAM_STATS_TOP_SPENDERS = new Req<
		{
			uid: string
			issuer?: number
			limit?: number
			currency?: string
			entity?: Exclude<TCompanyTransactionEntity, "all">
			tx_type?: TCompanyTransactionType
		},
		IAPIResponse<ITeamTopSpendersStats>
	>(undefined, "REQ_TEAM_STATS_TOP_SPENDERS")
	static REQ_TEAM_STATS_TRANSACTION_STATUS = new Req<
		{ uid: string; days?: number; currency?: string; issuer?: number },
		IAPIResponse<ITeamTransactionStatusStats>
	>(undefined, "REQ_TEAM_STATS_TRANSACTION_STATUS")
	static REQ_TEAM_USER_ADD = new Req<
		{ user_uid: string; uid: string; team_uid: string },
		IAPIResponse<IStatusResponse>
	>(undefined, "REQ_TEAM_USER_ADD")
	static REQ_TEAM_USER_DISABLE = new Req<
		{ user_uid: string; uid: string },
		IAPIResponse<ITeamUserDisableResponse>
	>(undefined, "REQ_TEAM_USER_DISABLE")
	static REQ_TEAM_USER_TOPUP = new Req<
		{ user_uid: string; uid: string; amount: number; currency: string; issuer?: number },
		IAPIResponse<IStatusResponse>
	>(undefined, "REQ_TEAM_USER_TOPUP")
	static REQ_TEAM_USER_WITHDRAW = new Req<
		ITeamUserWithdrawRequest,
		IAPIResponse<ITeamUserWithdrawResponse>
	>(undefined, "REQ_TEAM_USER_WITHDRAW")
	static REQ_USERS_LIST_TEAM = new Req<
		{ uid?: string; team_uid?: string },
		IAPIResponse<IUserSaved[]>
	>(undefined, "REQ_USERS_LIST_TEAM")
	static S_TEAMS_LIST_UPDATED = new Signal<ITeamSaved[]>("S_TEAMS_LIST_UPDATED")

	// COMMON
	static REQ_COMMON_CARD_CURRENCIES = new Req<
		{ card_holder_uid?: string },
		IAPIResponse<{ code: string }[]>
	>(undefined, "REQ_COMMON_CARD_CURRENCIES")
	static REQ_COMMON_CARD_SCHEMES = new Req<
		{ card_holder_uid?: string },
		IAPIResponse<{ code: number; name: string }[]>
	>(undefined, "REQ_COMMON_CARD_SCHEMES")
	static REQ_COMMON_CARD_TYPES = new Req<
		{ card_holder_uid?: string },
		IAPIResponse<{ code: number; name: string }[]>
	>(undefined, "REQ_COMMON_CARD_TYPES")
	static REQ_COMMON_CITIES = new Req<
		{ countryCode: string; issuer: number },
		IAPIResponse<ICity[]>
	>(undefined, "REQ_COMMON_CITIES")

	// USERS
	static REQ_USERS = new Req<
		void | { options?: { include_teams: boolean }; issuer?: number },
		IAPIResponse<IUserSaved[]>
	>(undefined, "REQ_USERS")
	/** One page of users/list with totals (`with_meta`); each user once. Older backends answer with the bare array. */
	static REQ_USERS_PAGE = new Req<
		IUserListQuery & { limit?: number; offset?: number },
		IAPIResponse<IListPage<IUserSaved, IUserListSummary> | IUserSaved[]>
	>(undefined, "REQ_USERS_PAGE")
	static REQ_GET_USER_TEMPLATE = new Req<void, IAPIResponse<IUserRaw>>(
		undefined,
		"REQ_GET_USER_TEMPLATE"
	)
	static REQ_CREATE_USER = new Req<IUserRaw, IAPIResponse<IUserRaw>>(
		undefined,
		"REQ_CREATE_USER"
	)
	static REQ_GET_USER = new Req<string, IAPIResponse<IUserSaved>>(
		undefined,
		"REQ_GET_USER"
	)
	static REQ_UPDATE_USER = new Req<IUserSaved, IAPIResponse<IStatusResponse>>(
		undefined,
		"REQ_UPDATE_USER"
	)
	static REQ_GET_USER_ROLE = new Req<
		{ uid: string },
		IAPIResponse<IUserRoleForm>
	>(undefined, "REQ_GET_USER_ROLE")
	static REQ_SET_USER_ROLE = new Req<
		Pick<IUserRoleForm, "uid" | "company_role">,
		IAPIResponse<IStatusResponse>
	>(undefined, "REQ_SET_USER_ROLE")
	static REQ_GET_MY_PROFILE = new Req<
		void | { include_teams?: boolean },
		IAPIResponse<TUser>
	>(undefined, "REQ_GET_MY_PROFILE")
	static REQ_UPDATE_MY_PROFILE = new Req<
		{ name: string },
		IAPIResponse<IStatusResponse>
	>(undefined, "REQ_UPDATE_MY_PROFILE")
	static REQ_CHANGE_MY_PASSWORD = new Req<
		{ old_password: string; password: string },
		IAPIResponse<IStatusResponse>
	>(undefined, "REQ_CHANGE_MY_PASSWORD")
	static REQ_USER_DELETE = new Req<void, IAPIResponse<IStatusResponse>>(
		undefined,
		"REQ_USER_DELETE"
	)
	static REQ_USER_BLOCK = new Req<
		{ user_uid: string; mode: "freeze" | "block" },
		IAPIResponse<IUserBlockResponse>
	>(undefined, "REQ_USER_BLOCK")
	static REQ_USER_BLOCK_PREVIEW = new Req<
		{ user_uid: string; refresh?: boolean },
		IAPIResponse<IUserBlockPreview>
	>(undefined, "REQ_USER_BLOCK_PREVIEW")
	static REQ_USER_BLOCK_STATUS = new Req<
		{ operation_uid: string },
		IAPIResponse<IUserBlockStatus>
	>(undefined, "REQ_USER_BLOCK_STATUS")
	static REQ_USER_UNBLOCK = new Req<
		{ user_uid: string; unfreeze_cards?: "true" | "false" },
		IAPIResponse<IUserUnblockResponse>
	>(undefined, "REQ_USER_UNBLOCK")
	static S_USERS_LIST_UPDATED = new Signal<IUserSaved[]>("S_USERS_LIST_UPDATED")
	static REQ_USER_TOPUP_TEMPLATE = new Req<void, IAPIResponse<IUserTopUp>>(
		undefined,
		"REQ_USER_TOPUP_TEMPLATE"
	)
	static REQ_USER_CARD_ISSUE_LIMIT_TEMPLATE = new Req<
		void,
		IAPIResponse<IUserCardIssueLimit>
	>(undefined, "REQ_USER_CARD_ISSUE_LIMIT_TEMPLATE")
	static REQ_USER_CARD_ISSUE_LIMIT = new Req<
		IUserCardIssueLimit,
		IAPIResponse<IStatusResponse>
	>(undefined, "REQ_USER_CARD_ISSUE_LIMIT")

	// ACCOUNTS
	static REQ_ACCOUNTS = new Req<
		void | Record<string, unknown>,
		IAPIResponse<IAccountSaved[]>
	>(undefined, "REQ_ACCOUNTS")
	static REQ_GET_ACCOUNT_TEMPLATE = new Req<void, IAPIResponse<IAccountRaw>>(
		undefined,
		"REQ_GET_ACCOUNT_TEMPLATE"
	)
	static REQ_CREATE_ACCOUNT = new Req<IAccountRaw, IAPIResponse<IAccountRaw>>(
		undefined,
		"REQ_CREATE_ACCOUNT"
	)
	static REQ_GET_ACCOUNT = new Req<string, IAPIResponse<IAccountSaved>>(
		undefined,
		"REQ_GET_ACCOUNT"
	)
	static REQ_UPDATE_ACCOUNT = new Req<IAccountSaved, IAPIResponse<boolean>>(
		undefined,
		"REQ_UPDATE_ACCOUNT"
	)
	static REQ_ACCOUNT_ADD_FUNDS = new Req<
		{ uid: string; amount: number },
		IAPIResponse<boolean>
	>(undefined, "REQ_ACCOUNT_ADD_FUNDS")
	static REQ_ACCOUNT_BLOCK = new Req<{ uid: string }, IAPIResponse<boolean>>(
		undefined,
		"REQ_ACCOUNT_BLOCK"
	)
	static S_ACCOUNTS_LIST_UPDATED = new Signal<IAccountSaved[]>("S_ACCOUNTS_LIST_UPDATED")

	// AGENTS
	static REQ_AGENTS = new Req<
		void | Record<string, unknown>,
		IAPIResponse<IAgentSaved[]>
	>(undefined, "REQ_AGENTS")
	static REQ_GET_AGENT_TEMPLATE = new Req<void, IAPIResponse<IAgentRaw>>(
		undefined,
		"REQ_GET_AGENT_TEMPLATE"
	)
	static REQ_CREATE_AGENT = new Req<IAgentRaw, IAPIResponse<IAgentRaw>>(
		undefined,
		"REQ_CREATE_AGENT"
	)
	static REQ_GET_AGENT = new Req<string, IAPIResponse<IAgentSaved>>(
		undefined,
		"REQ_GET_AGENT"
	)
	static REQ_UPDATE_AGENT = new Req<IAgentSaved, IAPIResponse<boolean>>(
		undefined,
		"REQ_UPDATE_AGENT"
	)

	// CAMPAIGNS
	static REQ_CAMPAIGNS = new Req<
		void | Record<string, unknown>,
		IAPIResponse<ICampaignSaved[]>
	>(undefined, "REQ_CAMPAIGNS")
	static REQ_GET_CAMPAIGN_TEMPLATE = new Req<void, IAPIResponse<ICampaignRaw>>(
		undefined,
		"REQ_GET_CAMPAIGN_TEMPLATE"
	)
	static REQ_CREATE_CAMPAIGN = new Req<ICampaignRaw, IAPIResponse<ICampaignRaw>>(
		undefined,
		"REQ_CREATE_CAMPAIGN"
	)
	static REQ_GET_CAMPAIGN = new Req<string, IAPIResponse<ICampaignSaved>>(
		undefined,
		"REQ_GET_CAMPAIGN"
	)
	static REQ_UPDATE_CAMPAIGN = new Req<ICampaignSaved, IAPIResponse<boolean>>(
		undefined,
		"REQ_UPDATE_CAMPAIGN"
	)

	// COMPANIES
	static REQ_COMPANIES = new Req<
		{ force?: boolean | undefined } | Record<string, unknown>,
		IAPIResponse<ICompanyRaw[]>
	>(undefined, "REQ_COMPANIES")
	static REQ_COMPANY_GET = new Req<string, IAPIResponse<ICompanyRaw>>(
		undefined,
		"REQ_COMPANY_GET"
	)
	static REQ_COMPANY_UPDATE = new Req<ICompanyRaw, IAPIResponse<IStatusResponse>>(
		undefined,
		"REQ_COMPANY_UPDATE"
	)
	static REQ_COMPANY_REGISTER = new Req<ICompanyRaw, IAPIResponse<ICompanyRaw>>(
		undefined,
		"REQ_COMPANY_REGISTER"
	)
	static REQ_COMPANY_TEMPLATE = new Req<void, IAPIResponse<ICompanyRaw>>(
		undefined,
		"REQ_COMPANY_TEMPLATE"
	)
	static REQ_COMPANY_USER_DISABLE = new Req<
		{ user_uid: string },
		IAPIResponse<IStatusResponse>
	>(undefined, "REQ_COMPANY_USER_DISABLE")
	static REQ_COMPANY_TOPUP = new Req<
		{ amount: number; currency: string },
		IAPIResponse<IStatusResponse>
	>(undefined, "REQ_COMPANY_TOPUP")
	static REQ_COMPANY_TOPUP_TEMPLATE = new Req<void, IAPIResponse<any>>(
		undefined,
		"REQ_COMPANY_TOPUP_TEMPLATE"
	)
	static S_COMPANY_LIST_UPDATED = new Signal<ICompanyRaw[]>("S_COMPANY_LIST_UPDATED")
}
